import { __assign } from 'tslib';
import * as React from 'react';

var Item = function (props) {
    var className = props.className, dividerClassName = props.dividerClassName, horizontalSize = props.horizontalSize, verticalSize = props.verticalSize, length = props.length, direction = props.direction, index = props.index, children = props.children, divider = props.divider, wrap = props.wrap, useCssGaps = props.useCssGaps;
    var style;
    if (!useCssGaps) {
        if (direction === 'vertical') {
            if (index < length - 1) {
                style = { marginBottom: horizontalSize / (divider ? 2 : 1) };
            }
        }
        else {
            style = __assign(__assign({}, (index < length - 1 && { marginRight: horizontalSize / (divider ? 2 : 1) })), (wrap && { paddingBottom: verticalSize }));
        }
    }
    if (children === null || children === undefined) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: className, style: style }, children),
        index < length - 1 && divider && (React.createElement("span", { className: dividerClassName, style: style }, divider))));
};

export { Item as default };
